import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import config from 'config/config';
import checkOrSetSlash from 'utils/checkOrSetSlash';
import { prepareFCHeader } from 'utils/request';

const baseUrl = `${checkOrSetSlash(config.apiHostGateway, 'apiHostGateway')}api/`;

export const projectsApi = createApi({
  reducerPath: 'projectsApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: prepareFCHeader(),
  }),
  tagTypes: ['ProjectsList'],
  endpoints: builder => ({
    fetchProjects: builder.query({
      query: ({ organizationId, workspaceIds = [] }) => ({
        url: `v2.5/projects/filters`,
        params: {
          business_organization_id: organizationId,
          limit: 1000,
          offset: 0,
        },
        body: {
          workspace_ids: workspaceIds,
        },
        method: 'POST',
      }),
      providesTags: ['ProjectsList'],
    }),
  }),
});

export const { useFetchProjectsQuery } = projectsApi;
